module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-8-m4.3c9dcedb.jpg";